module.exports = __webpack_public_path__ + "static/img/code.1229122.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/code.jpg
// module id = 24Xq
// module chunks = 9